
import { KayaMemberContent } from "../../components/kaya"

export default function KayaMember () {

  return (
      <>
        <KayaMemberContent/>
      </>
  )

}